import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Modal from '@mui/material/Modal'; // Import Modal from MUI or your modal library

interface User {
  firstName: string;
  lastName: string;
  email: string;
  companyName: string;
  expertise: string;
  userType: 'internal' | 'external';
}

const UserRequest: React.FC = () => {
  const [internalUsers, setInternalUsers] = useState<User[]>([]);
  const [externalUsers, setExternalUsers] = useState<User[]>([]);
  const [activeTab, setActiveTab] = useState<'internal' | 'external'>('internal');
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const [modalOpen, setModalOpen] = useState(false);
  const [modalAction, setModalAction] = useState<"approve" | "reject" | null>(null);
  const [selectedUserEmail, setSelectedUserEmail] = useState<string | null>(null);
  const [selectedUserExpertise, setSelectedUserExpertise] = useState<string | null>(null);
  const [isUpdatingStatus, setIsUpdatingStatus] = useState(false);

  const fetchUsers = async (organizationType: 'Motherson' | 'External') => {
    try {
      setLoading(true);
      setError(null);
      const Email=localStorage.getItem('Email');

      const response = await fetch('/get_usersignup_requests', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ Email: Email }),
      });

      if (!response.ok) {
        throw new Error(`API error: ${response.statusText}`);
      }

      const data = await response.json();

      const userType = organizationType === 'Motherson' ? 'internal' : 'external';

      const transformed: User[] = data.map((user: any) => ({
        firstName: user.FirstName || '',
        lastName: user.LastName || '',
        email: user.Email || '',
        companyName: user.Company_Name || '',
        expertise: user.Expertise || '',
        userType,
      }));

      if (userType === 'internal') {
        setInternalUsers(transformed);
      } else {
        setExternalUsers(transformed);
      }
    } catch (err: any) {
      setError(err.message || 'Unknown error');
    } finally {
      setLoading(false);
    }
  };

useEffect(() => {

  fetchUsers('Motherson');
  fetchUsers('External');
}, []);


  // useEffect(() => {
  //   fetchUsers('Motherson');
  // }, []);

  const handleTabChange = (tab: 'internal' | 'external') => {
    setActiveTab(tab);

    if (tab === 'external' && externalUsers.length === 0) {
      fetchUsers('External');
    }
  };

  const openConfirmModal = (email: string, action: "approve" | "reject", expertise: string) => {
    setSelectedUserEmail(email);
    setModalAction(action);
    setSelectedUserExpertise(expertise);
    setModalOpen(true);
  };

  const closeConfirmModal = () => {
    setModalOpen(false);
    setSelectedUserEmail(null);
    setModalAction(null);
    setSelectedUserExpertise(null);
  };

  const updateUserStatus = async (email: string, status: 'A' | 'R', expertise: string) => {
     setIsUpdatingStatus(true);
    try {
      const response = await fetch('/update_user_status', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ Email: email, Status: status, Expertise: expertise }),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.error || 'Failed to update status');
      }

      if (status === 'A') {
        toast.success(result.message || 'User approved successfully', {
          className: 'custom-toast',
        });
      } else if (status === 'R') {
        toast.error(result.message || 'User rejected successfully');
      }

      if (activeTab === 'internal') {
        fetchUsers('Motherson');
      } else {
        fetchUsers('External');
      }
      closeConfirmModal();
    } catch (error: any) {
      alert(error.message || 'Error updating user status');
    }finally{
       setIsUpdatingStatus(false);
    }
  };

  const renderTable = (users: User[]) => (
    <div>
     {/* <Box className="screen-title-header">
        <Typography variant="h4" gutterBottom>
          User Access Management
        </Typography>        
      </Box> */}

    <div className='tableWrapperOuter'>
      <div className='tableWrapper_admin'>
        <table>
          <thead style={{ position: 'sticky', top: -1, backgroundColor: '#f9f9f9' }}>
            <tr>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Email</th>
              <th>Company Name</th>
              <th>Expertise</th>
              <th style={{width:"100px"}}>Action</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={6} align="center">Loading...</td></tr>
            ) : error ? (
              <tr><td colSpan={6} align="center" style={{ color: 'red' }}>{error}</td></tr>
            ) : users.length === 0 ? (
              <tr><td colSpan={6} align="center">No users found.</td></tr>
            ) : (
              users.map((user) => (
                <tr key={user.email}>
                  <td>{user.firstName}</td>
                  <td>{user.lastName}</td>
                  <td>{user.email}</td>
                  <td>{user.companyName}</td>
                  <td>{user.expertise}</td>
                  <td>
                    <button className='action-aprove-btn' onClick={() => openConfirmModal(user.email, 'approve', user.expertise)}>
                      <i title="Approve">
                        <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="100%" width="100%" xmlns="http://www.w3.org/2000/svg"><path d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"></path></svg>
                      </i>
                    </button>
                    <button className='action-reject-btn' onClick={() => openConfirmModal(user.email, 'reject', user.expertise)}>
                      <i title="Reject">
                        <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" fill-rule="evenodd" height="100%" width="100%" xmlns="http://www.w3.org/2000/svg"><path d="M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64Zm0 76c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372Zm128.013 198.826c.023.007.042.018.083.059l45.02 45.019c.04.04.05.06.058.083a.118.118 0 0 1 0 .07c-.007.022-.018.041-.059.082L557.254 512l127.861 127.862a.268.268 0 0 1 .05.06l.009.023a.118.118 0 0 1 0 .07c-.007.022-.018.041-.059.082l-45.019 45.02c-.04.04-.06.05-.083.058a.118.118 0 0 1-.07 0c-.022-.007-.041-.018-.082-.059L512 557.254 384.14 685.115c-.042.041-.06.052-.084.059a.118.118 0 0 1-.07 0c-.022-.007-.041-.018-.082-.059l-45.02-45.019c-.04-.04-.05-.06-.058-.083a.118.118 0 0 1 0-.07c.007-.022.018-.041.059-.082L466.745 512l-127.86-127.86a.268.268 0 0 1-.05-.061l-.009-.023a.118.118 0 0 1 0-.07c.007-.022.018-.041.059-.082l45.019-45.02c.04-.04.06-.05.083-.058a.118.118 0 0 1 .07 0c.022.007.041.018.082.059L512 466.745l127.862-127.86c.04-.041.06-.052.083-.059a.118.118 0 0 1 .07 0Z"></path></svg>
                      </i>
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
    </div>
  );

  return (
    <div className="admin-wrapper">
      <ToastContainer />
      <div className="admin-body-container">
        <div className="page-wrapper" style={{ display: 'flex', flexDirection: 'column' }}>

          {/* Tabs */}
          <div className='tabWrapper'>
            <button
              className={activeTab === 'internal' ? 'adminTabButton active' : 'adminTabButton'}
              onClick={() => handleTabChange('internal')}
            >
              Internal Users ({internalUsers.length})
            </button>
            <button
              className={activeTab === 'external' ? 'adminTabButton active' : 'adminTabButton'}
              onClick={() => handleTabChange('external')}
            >
              External Users ({externalUsers.length})
            </button>
          </div>

          {/* Table */}
          {activeTab === 'internal' && renderTable(internalUsers)}
          {activeTab === 'external' && renderTable(externalUsers)}

          {/* Confirmation Modal */}

   <Modal
  open={modalOpen}
  onClose={closeConfirmModal}
  aria-labelledby="confirm-action-title"
  aria-describedby="confirm-action-description"
  className="confirmationModal"
  style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }}
>
  <div
    style={{
      backgroundColor: 'white',
      padding: '20px',
      borderRadius: '8px',
      minWidth: '320px',
      maxWidth: '90%',
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    }}
  >
    <h3 id="confirm-action-title">
      Are you sure you want to {modalAction === 'approve' ? 'approve' : 'reject'} this user?
    </h3>
    <p id="confirm-action-description" style={{ marginBottom: '20px' }}>
      {modalAction === 'approve'
        ? 'This user will be granted access.'
        : 'This user will be rejected and removed.'}
    </p>
    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
      <button
        onClick={() => {
          if (selectedUserEmail && modalAction && selectedUserExpertise) {
            updateUserStatus(
              selectedUserEmail,
              modalAction === 'approve' ? 'A' : 'R',
              selectedUserExpertise
            );
          }
        }}
        style={{
          backgroundColor: modalAction === 'approve' ? '#28a745' : '#ff4d4f',
          color: 'white',
          border: 'none',
          padding: '8px 16px',
          borderRadius: '5px',
          cursor: isUpdatingStatus ? 'not-allowed' : 'pointer',
          fontWeight: 'bold',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        disabled={isUpdatingStatus}
      >
        {isUpdatingStatus && <span className="spinner" />}
        {modalAction === 'approve' ? 'Approve' : 'Reject'}
      </button>
      <button
        onClick={closeConfirmModal}
        style={{
          backgroundColor: '#ccc',
          color: '#333',
          border: 'none',
          padding: '8px 16px',
          borderRadius: '5px',
          cursor: isUpdatingStatus ? 'not-allowed' : 'pointer',
        }}
        disabled={isUpdatingStatus}
      >
        Cancel
      </button>
    </div>
  </div>
</Modal>

          {/* <Modal
            open={modalOpen}
            onClose={closeConfirmModal}
            aria-labelledby="confirm-action-title"
            aria-describedby="confirm-action-description"
            className="confirmationModal"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <div
              style={{
                backgroundColor: 'white',
                padding: '20px',
                borderRadius: '8px',
                minWidth: '320px',
                maxWidth: '90%',
                boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
              }}
            >
              <h3 id="confirm-action-title">
                Are you sure you want to {modalAction === 'approve' ? 'approve' : 'reject'} this user?
              </h3>
              <p id="confirm-action-description" style={{ marginBottom: '20px' }}>
                {modalAction === 'approve'
                  ? 'This user will be granted access.'
                  : 'This user will be rejected and removed.'}
              </p>
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                <button
                  onClick={() => {
                    if (selectedUserEmail && modalAction && selectedUserExpertise) {
                      updateUserStatus(
                        selectedUserEmail,
                        modalAction === 'approve' ? 'A' : 'R',
                        selectedUserExpertise
                      );
                    }
                 //   closeConfirmModal();
                  }}
                  style={{
                    backgroundColor: modalAction === 'approve' ? '#28a745' : '#ff4d4f',
                    color: 'white',
                    border: 'none',
                    padding: '8px 16px',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                  }}
                >
                  {modalAction === 'approve' ? 'Approve' : 'Reject'}
                </button>
                <button
                  onClick={closeConfirmModal}
                  style={{
                    backgroundColor: '#ccc',
                    color: '#333',
                    border: 'none',
                    padding: '8px 16px',
                    borderRadius: '5px',
                    cursor: 'pointer',
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </Modal> */}
        </div>
      </div>
    </div>
  );
};

export default UserRequest;
